import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from 'file-saver';
import { baseUrl, getDateWithDay } from "../../comman/config.js";
import { MainRequirementFilter } from "../../components/Filter/MainRequirementFilter.js";
import toast, { Toaster } from "react-hot-toast";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import Loader from '../../components/Loader'
import IssueModal from "../../components/IssueModal.js";
import Select from 'react-select';
import * as XLSX from 'xlsx';
import { menuAboveTable } from "../../comman/selectMenu";
// import Pagination from "react-js-pagination";

// The rows this screen works with: the kit's planned ingredients, plus the ones put in by hand
// with "Add Ingredient".
//
// An added ingredient is not in the recipe, so it has no required qty -- `required_qty > 0` alone
// leaves it out. It is flagged isNew while it is only on screen, and manually_added once it has
// been saved and read back (see getBatchIngredientsWithDetails, which merges those rows in).
//
// Defined once because the same question is asked in six places -- what to draw, what to check,
// what to send -- and Submit for Issue was the one place asking it the short way. The added row
// was drawn, could be ticked, and was then dropped from the POST: never issued from the kit, and
// never written to production_receipe_planning, which is what Production Support reads.
const isIssuableRow = (item) => item?.required_qty > 0 || item?.isNew || item?.manually_added;

function IssueList() {
  // Received, and the difference against it, are the SuperAdmin's alone. They come from
  // Production Support -- what the kitchen says it actually received -- and reading a store's
  // issue against it is a reconciliation, not part of issuing. Role 0, not an operation: it is
  // not "may you delete things", it is "are you the person who reconciles".
  const isSuperadminSession = String(localStorage.getItem('userRole')) === '0';
  const today = new Date().toISOString().split("T")[0];
  const [requirementList, setRequirementList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [session, setSession] = useState({});
  const [issueStatus, setIssueStatus] = useState([]);
  const [item, setItem] = useState({});
  const [kit,setKit] = useState({})
  const [kitList,setKitList] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemIngredientList, setItemIngredientList] = useState([]);
  const [methodList, setMethodList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)


  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    getMethodList()
  }, []);

  useEffect(()=>{
    getIngredientList()
  },[itemIngredientList])

  useEffect(() => {
   
    if(fromDate && toDate){
      getKitList();
    }
  }, [fromDate, toDate, session, item, issueStatus])

  useEffect(()=>{
    if(activeIndex !== null){
      getKitItemsList()
    }
  },[kit,item,activeIndex])

  const handelFilterChange = async (from_date, to_date, session, item, issueStatus) => {
        setActiveIndex(null)
        setFromDate(from_date);
        setToDate(to_date);
        setSession(session);
        setItem(item);
        setIssueStatus(issueStatus)
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = itemIngredientList?.map(item => item.ingredient_id) || [];
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 1 && !existingIngredientIds.includes(item.id));
    // console.log(list)
    setIngredientList(list);
  };

  const getMethodList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=method_master&condition=status=1`
    );
    setMethodList(response.data.data);
  };

  // const getKitItemsList = async ()=>{
  //   setLoading(true);
  //   const kit = kitList.find((item, index) => index == activeIndex);
  //   // console.log(kit)
  //   const condition = `pr.menu_item_id='${kit.menu_item_id}' AND pr.date = '${kit.date}' AND pr.session='${kit.session}' AND pr.batch = '${kit.batch}' AND im.store = 1`;
  //   const RecipeDbData = await axios.get(`${baseUrl}/main_store_issue/ingredient_list?condition=${condition}`);
  //   const ingredientsList = RecipeDbData.data.data;
   
  //   if(ingredientsList.length > 0){
  //     const updatedIngredientsList = [];
  //     for (const i of ingredientsList) {
      
  //         const condition = `date = '${kit.date}' AND session = '${kit.session}' AND menu_item_id = '${kit.menu_item_id}' AND batch = '${kit.batch}' AND ingredient_id = '${i.ingredient_id}'`;
  //         // console.log(condition);
  //         const response = await axios.get( `${baseUrl}/comman/list?table=item_requirement_detail&condition=${condition}`);
          
  //         let net_issued_qty;
  //         let net_issue_status;
  //         if(response.data.data.length > 0){
  //           net_issued_qty = response.data.data[0].net_issued_qty;
  //           net_issue_status = response.data.data[0].issue_net_status;
  //           // console.log(response.data.data);
  //         }

  //       const receivedCondition = `date = '${kit.date}' AND session = '${kit.session}' AND menu_item_id = '${kit.menu_item_id}' AND batch = '${kit.batch}' AND ingredient_id = '${i.ingredient_id}' AND unit = '${i.unit}'`;
  //       const receivedRes = await axios.get(`${baseUrl}/comman/list?table=production_receipe_planning&condition=${receivedCondition}`);
  //       let received_qty = 0;
  //       if (receivedRes.data.data.length > 0) {
  //         received_qty = receivedRes.data.data[0].received_qty ?? 0;
  //       }
          
  //         updatedIngredientsList.push({
  //           ...i,
  //           net_issued_qty: net_issued_qty ?? 0,
  //           diff_qty : ((net_issued_qty ?? 0) - (i?.required_qty ?? 0)).toFixed(2),
  //           net_issue_status: net_issue_status ?? 1,
  //           received_qty,
  //           diff_received: ((net_issued_qty ?? 0) - received_qty).toFixed(2),
  //         });
  //       };
  //     // setSelectedItem(item);
  //     // console.log(updatedIngredientsList)
  //     setLoading(false);
  //     setItemIngredientList(updatedIngredientsList);
  //   }
  // }

  const getKitItemsList = async () => {
    setLoading(true);
    try {
      const kit = kitList.find((item, index) => index == activeIndex);
      // console.log("KIT:", kit)
      const kitParams = {
        menu_item_id: kit.menu_item_id,
        date: kit.date,
        session: kit.session,
        batch: kit.batch
      };
      
      // Make a single API call to get both ingredient list and their details
      const response = await axios.get(`${baseUrl}/main_store_issue/batch_ingredients`, {
        params: kitParams
      });
      
      if (response.data.status && response.data.data.length > 0) {
        setItemIngredientList(response.data.data);
      } else {
        setItemIngredientList([]);
      }
    } catch (error) {
      console.error("Error fetching kit items:", error);
    } finally {
      setLoading(false);
    }
  };

  const getKitList = async () => {
    setLoading(true);
    try {
      const params = { from_date: fromDate, to_date: toDate };
      if (session?.value && session?.value !== 'all') params.session = session.value;
      if (item?.value && item?.value !== 'all') params.menu_item_id = item.value;
      if (issueStatus.length > 0 && issueStatus !== 'undefined') {
        const hasAll = issueStatus.some((s) => s?.value == 0);
        if (!hasAll) {
          params.issue_statuses = issueStatus.map((s) => s?.value).join(',');
        }
      }
      const response = await axios.get(`${baseUrl}/main_store_issue/kit_list`, { params });
      setKitList(response.data.data ?? []);
    } catch (error) {
      console.error('Error fetching kit list:', error);
    } finally {
      setLoading(false);
    }
  }
  // const getRequirementList = async() => {
  //   // console.log(issueStatus);
  //   const response = await axios.post(`${baseUrl}/issue/list`,
  //     { from_date : fromDate,
  //       to_date :toDate,
  //       session :session?.value,
  //       item : item?.value,
  //       issue_status: issueStatus?.value
       
  //   });
  //   setRequirementList(response.data.data);
  // }

  
  // const handleSubmit = async() => {
   
  //   const response = await axios.post(`${baseUrl}/requirement/status_update`,
  //     { selectedRows : selectedRows,
  //       status: 2});

  //     toast.success("Data successfully saved!");
  //     getRequirementList();
  // };

//   const handleToggleSelect = (index) => {
//     const updatedSelectedRows = selectedRows.includes(requirementList[index])
//         ? selectedRows.filter(item => item !== requirementList[index]) // Deselect
//         : [...selectedRows, requirementList[index]]; // Select

//    setSelectedRows(updatedSelectedRows);
    

// };
// const handleSwitchSelectAll = () => {
//   if (selectAll) {
//       setSelectedRows([]);
//   } else {
//       setSelectedRows(requirementList.filter((item) => item.issue_status == 1)); // Select all rows
//   }
//   setSelectAll(!selectAll);
// };

  const clearItem = () => {
    setActiveIndex(null)
    setSelectedItem(null);
    setItemIngredientList(null);
    getKitList()
  };

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
    setKit(kitList.find((item, i) => i == index))
  };
  

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData];
      if(name === "net_issued_qty"){
        
        const required_qty = updatedFormData[index].required_qty;
        const diff_qty = (value - required_qty).toFixed(2);
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_qty : diff_qty };
      }else{
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
      }
      return updatedFormData;
    });
  };

  const handleAddButtonClick = (index) => {
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData];
      updatedFormData[index] = {...updatedFormData[index], add_issue: true};
      return updatedFormData;
    });
  }

  const handleSave = async() => {
    // e.preventDefault();
    // setLoading(true)
    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);

    if(selectedRows.some(item => item.net_issued_qty == 0 && item.issue_net_status == 1)){
      alert("One or more items have an empty issue qty value.");
      setSelectedRows([]);
      return;
    }
    // Added rows are checked too, and this is the check that catches an "Add Ingredient" row
    // left without an ingredient picked -- it would otherwise be sent with a null ingredient_id.
    if(selectedRows.filter(isIssuableRow).some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([]);
      return
    }
    // Issued more than required, on the other hand, is only a question worth asking of a row that
    // HAS a requirement. An added ingredient is not in the recipe, so anything issued against it
    // is over its requirement of zero, and warning about that every time would be noise.
    const issueCondition = selectedRows.filter(item => item?.required_qty > 0).some(item => 
      item.issue_status !== 3 && Number(item.net_issued_qty) > Number(item.required_qty)
    );

    if(issueCondition){
      const commonline = `ની ઇસ્યુ જથ્થો જરૂરી જથ્થો કરતાં વધુ છે.`
      let confirmMessage = ``
      console.log("selected rows:",selectedRows);
      selectedRows.filter(item => item?.required_qty > 0).forEach(item => {
        if(item.issue_status !== 3 && item.net_issued_qty > item.required_qty){
          confirmMessage += `${item.ingredient} ${commonline}\n`
        }
      })

      confirmMessage += `શું તમે આગળ વધવા માંગો છો?`
      const confirmed = window.confirm(confirmMessage)
      if (!confirmed) {
        setSelectedRows([]);
        return;
      }
    }
    try{
        
        // console.log(itemIngredientList,kit)
      const response = await axios.post(`${baseUrl}/main_store_issue/ingredient_update`,
        { ingredientsList : itemIngredientList.filter(isIssuableRow),
          selectedRows : selectedRows.filter(isIssuableRow),
          item: kit});
          toast.success("Item added successfully!");
      // window.location.reload();
      await getKitList();

      // const reopenedKitIndex = kitList.findIndex(k =>
      //   k.menu_item_id === kit.menu_item_id &&
      //   k.date === kit.date &&
      //   k.session === kit.session &&
      //   k.batch === kit.batch
      // );
      // console.log("reopenedKitIndex:", reopenedKitIndex);

      // if (reopenedKitIndex !== -1) {
      //   setActiveIndex(reopenedKitIndex);
      //   setKit(kitList[reopenedKitIndex]);
      //   getKitItemsList(); // fetch ingredients for the reopened kit
      // } else {
      //   clearItem(); // fallback if the kit is no longer found
      // }
          clearItem()
    }catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    // setLoading(false)
    setSelectedRows([]);
  }

  // console.log("item ingredient list:",itemIngredientList);

  const handleSwitchSelectAll = () => {
    if (selectAll) {
        setSelectedRows([]);
    } else {
        setSelectedRows(itemIngredientList.filter((item) => item.net_issue_status == 1 || item.net_issue_status == 2 || item.net_issue_status == 3 )); // Select all rows
    }
    setSelectAll(!selectAll);
  };

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(itemIngredientList[index])
        ? selectedRows.filter(item => item !== itemIngredientList[index]) // Deselect
        : [...selectedRows, itemIngredientList[index]]; // Select

   setSelectedRows(updatedSelectedRows);
    

};

  const handleSaveButton = async() => {
    const issueCondition = itemIngredientList.filter(isIssuableRow).some(item =>
      item.issue_status !== 3 && item.net_issued_qty > item.required_qty
    );

    try{

        // console.log(itemIngredientList,kit)
      const response = await axios.post(`${baseUrl}/main_store_issue/ingredient_save`,
        { ingredientsList : itemIngredientList.filter(isIssuableRow),
          item: kit});
          toast.success("Item saved successfully!");
          clearItem()
    }catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    
  }

  const handleExport = async(e, kit_no) => {
    e.preventDefault();
    try{
      const headerRow = ["Ingredient", "Required Qty", "Issue Qty", "Diff Qty", "Issue Status"];
     
      const xlsx = [headerRow].concat(
        itemIngredientList.map(item => {
             // Replace status values with "active" or "inactive"
            const status = item.net_issue_status == 3 ? "Issued" : (item.net_issue_status == 2 ? "Partly Issued" : "Pending");
             // Create an array of values, including the modified status
             return [item.ingredient, item.required_qty,item.net_issued_qty, item.diff_qty, status];
           }));

        // Convert the data to a worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(xlsx);

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Generate the XLSX file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
     
           // Create a Blob containing the CSV data
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream;' });
      
        // Trigger the file download using file-saver
        saveAs(blob, `Store Issue ${kit_no}.xlsx`);
    }catch (error) {
      toast.error("Failed to export item. Please try again.");
    }
  }


  const handleAddNewIngredientRow = ()=> {
    console.log("add new ingredient")
    setItemIngredientList([...itemIngredientList,{
      ingredient:'', 
      ingredient_obj:{},
      ingredient_id:null, 
      unit:null, 
      unitname:'', 
      wastage:0,
      gross_issued_qty:0, 
      // net_issued_qty:0, 
      gross_required_qty:0,
      required_qty:0,
      issue_status:1,
      isNew: true
    }])
    // console.log("item ingredient list:",itemIngredientList)
  }

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    // console.log(selectedOptions)
    const updatedList =   [...itemIngredientList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    updatedList[index].unit = selectedOptions.unit
    updatedList[index].unitname = selectedOptions.unitname
    // console.log(updatedList[index])
    setItemIngredientList(updatedList)
  }

  return (
    <div className="p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Main Store Issue
        </h1>

        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <MainRequirementFilter handleFilterChange={handelFilterChange} page="issue" />
      </div>

      <div>
        {kitList.map((item, index) => (
          <div key={index} className="border-b mt-4">
            <div
              className={`flex justify-between items-center p-4 cursor-pointer accordion-title border rounded 
              ${item.main_store_issue_status == 1 ? 'bg-orange-400' :
                  (item.main_store_issue_status == 2 ? 'bg-yellow-400' : 'bg-green-400')}`}
              onClick={() => handleClick(index)}>
              <span className="text-sm sm:text-base break-words">{`${item.kit_no} (${item.main_store_issue_status == 1 ? 'Pending issue' : (item.main_store_issue_status == 2 ? "Partly Issued" : "Issued")})`}</span>
              {index === activeIndex ? (
                <ChevronUpIcon className="w-6 h-6 flex-shrink-0" />
              ) : (
                <ChevronDownIcon className="w-6 h-6 flex-shrink-0" />
              )}
            </div>
            {index === activeIndex && (
              <div className="space-y-2 p-4">
                <div>
                  {/* Desktop Table View */}
                  <div className="hidden lg:block">
                    <table className="w-full mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="px-2 py-1 border border-black text-center">
                            <input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} />
                          </th>
                          <th scope="col" className="px-2 py-1 border border-black text-center w-60">Ingredient</th>
                          <th scope="col" className="px-2 py-1 border border-black text-center">Required Qty</th>
                          <th scope="col" className="px-2 py-1 border border-black text-center">Issue Qty</th>
                          <th scope="col" className="px-2 py-1 border border-black text-center">Diff Qty. (Required)</th>
                          {isSuperadminSession && <th scope="col" className="px-2 py-1 border border-black text-center">Received</th>}
                          {isSuperadminSession && <th scope="col" className="px-2 py-1 border border-black text-center">Diff Qty. (Received)</th>}
                          <th scope="col" className="px-2 py-1 border border-black text-center">Issue Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemIngredientList?.filter(isIssuableRow)?.slice()?.sort((a, b) => {
                          // Match Recipe Planning ordering: main items first, then required_qty (proportional to qty/100kg) descending within each group
                          if (!!a.is_main !== !!b.is_main) return a.is_main ? -1 : 1;
                          return (parseFloat(b.required_qty) || 0) - (parseFloat(a.required_qty) || 0);
                        })?.map((item, filteredIndex) => {
                          const originalIndex = itemIngredientList.findIndex(origItem => origItem === item);
                          return (
                            <tr key={originalIndex} className="border border-black-b">
                              {(((item.net_issue_status !== 3) || (item.net_issue_status === 3 && item.add_issue)) && ((item.net_issue_status !== 2) || (item.net_issue_status === 2 && item.add_issue))) ? (
                                <td className="px-2 py-1 border border-black text-center">
                                  <input
                                    type="checkbox"
                                    checked={selectedRows.includes(item)}
                                    onChange={() => handleToggleSelect(originalIndex)}
                                  />
                                </td>
                              ) : (
                                <td className="px-2 py-1 border border-black text-center"></td>
                              )}
                              {item.isNew ? (
                                <td className="px-2 py-1 border border-black text-center">
                                  <Select
                                    {...menuAboveTable}
                                    classNamePrefix="select"
                                    className='basic-multi-select'
                                    value={item.ingredient_obj}
                                    name="ingredient"
                                    onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, originalIndex)}
                                    options={ingredientList.map((item) => ({
                                      value: item.id,
                                      label: `${item.ingredient} (${item.eng_name})`,
                                      unit: item.unit?.id,
                                      unitname: item.unit?.name,
                                      ingredient: `${item.ingredient}`,
                                      eng_name: item.eng_name,
                                    }))}
                                    placeholder="Ingredient List"
                                    filterOption={(option, inputValue) => {
                                      return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                    }}
                                  />
                                </td>
                              ) : (
                                <td className="px-2 py-1 border border-black text-center">{item.ingredient}</td>
                              )}
                              <td className="px-2 py-1 border border-black text-center">{parseFloat(item?.required_qty || 0).toFixed(2)}</td>
                              <td className="px-2 py-1 border border-black text-center">
                                <input type="number"
                                  id="net_issued_qty"
                                  name="net_issued_qty"
                                  value={item?.net_issued_qty}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={handleInputChange(originalIndex)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                      e.preventDefault();
                                    }
                                  }}
                                  className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                />
                                {(item.net_issue_status === 3 || item.net_issue_status === 2) && (
                                  <>
                                    <button
                                      onClick={() => handleAddButtonClick(originalIndex)}
                                      className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                                    >
                                      &#x2b;
                                    </button>
                                    {item.add_issue && (
                                      <input
                                        type="number"
                                        id="add_issued_qty"
                                        name="add_issued_qty"
                                        value={item?.add_issued_qty ?? ''}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={handleInputChange(originalIndex)}
                                        onKeyDown={(e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                          }
                                        }}
                                        className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                      />
                                    )}
                                  </>
                                )}
                              </td>
                              <td className={`px-2 py-1 border border-black text-center ${item.diff_qty < 0 ? 'bg-red-300 text-black' : ''}`}>{parseFloat(item?.diff_qty || 0).toFixed(2)}</td>
                              {isSuperadminSession && <td className="px-2 py-1 border border-black text-center">
                                {parseFloat(item.received_qty || 0).toFixed(2)}
                              </td>}
                              {isSuperadminSession && <td className={`px-2 py-1 border border-black text-center ${item.diff_received < 0 ? 'bg-red-300 text-black' : ''}`}>
                                {parseFloat(item.diff_received || 0).toFixed(2)}
                              </td>}
                              <td className="px-2 py-1 border border-black text-center">{item.net_issue_status == 3 ? "Issued" : (item.net_issue_status == 2 ? "Partly Issue" : "Pending")}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View */}
                  <div className="block lg:hidden">
                    <div className="mb-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-medium">Select All</span>
                        <input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} />
                      </div>
                    </div>

                    {itemIngredientList?.filter(isIssuableRow)?.slice()?.sort((a, b) => {
                          // Match Recipe Planning ordering: main items first, then required_qty (proportional to qty/100kg) descending within each group
                          if (!!a.is_main !== !!b.is_main) return a.is_main ? -1 : 1;
                          return (parseFloat(b.required_qty) || 0) - (parseFloat(a.required_qty) || 0);
                        })?.map((item, filteredIndex) => {
                      const originalIndex = itemIngredientList.findIndex(origItem => origItem === item);
                      return (
                        <div key={originalIndex} className="border rounded-lg p-3 mb-3 bg-white shadow-sm">
                          <div className="flex items-center justify-between mb-3">
                            <div className="flex-1">
                              {item.isNew ? (
                                <Select
                                  {...menuAboveTable}
                                  classNamePrefix="select"
                                  className='basic-multi-select'
                                  value={item.ingredient_obj}
                                  name="ingredient"
                                  onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, originalIndex)}
                                  options={ingredientList.map((item) => ({
                                    value: item.id,
                                    label: `${item.ingredient} (${item.eng_name})`,
                                    unit: item.unit?.id,
                                    unitname: item.unit?.name,
                                    ingredient: `${item.ingredient}`,
                                    eng_name: item.eng_name,
                                  }))}
                                  placeholder="Ingredient List"
                                  filterOption={(option, inputValue) => {
                                    return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                  }}
                                />
                              ) : (
                                <div className="font-medium text-sm">{item.ingredient}</div>
                              )}
                              <div className="text-xs text-gray-500 mt-1">
                                Status: {item.net_issue_status == 3 ? "Issued" : (item.net_issue_status == 2 ? "Partly Issue" : "Pending")}
                              </div>
                            </div>
                            {(((item.net_issue_status !== 3) || (item.net_issue_status === 3 && item.add_issue)) && ((item.net_issue_status !== 2) || (item.net_issue_status === 2 && item.add_issue))) && (
                              <input
                                type="checkbox"
                                checked={selectedRows.includes(item)}
                                onChange={() => handleToggleSelect(originalIndex)}
                                className="ml-2"
                              />
                            )}
                          </div>

                          <div className="grid grid-cols-2 gap-2 text-sm">
                            <div>
                              <div className="text-xs text-gray-500">Required Qty</div>
                              <div className="font-medium">{parseFloat(item?.required_qty || 0).toFixed(2)}</div>
                            </div>
                            {isSuperadminSession && <div>
                              <div className="text-xs text-gray-500">Received</div>
                              <div className="font-medium">{parseFloat(item.received_qty || 0).toFixed(2)}</div>
                            </div>}
                            <div>
                              <div className="text-xs text-gray-500">Diff Qty (Required)</div>
                              <div className={`font-medium ${item.diff_qty < 0 ? 'text-red-600' : ''}`}>
                                {parseFloat(item?.diff_qty || 0).toFixed(2)}
                              </div>
                            </div>
                            {isSuperadminSession && <div>
                              <div className="text-xs text-gray-500">Diff Qty (Received)</div>
                              <div className={`font-medium ${item.diff_received < 0 ? 'text-red-600' : ''}`}>
                                {parseFloat(item.diff_received || 0).toFixed(2)}
                              </div>
                            </div>}
                          </div>

                          <div className="mt-3">
                            <div className="text-xs text-gray-500 mb-1">Issue Qty</div>
                            <div className="flex items-center gap-2">
                              <input type="number"
                                id="net_issued_qty"
                                name="net_issued_qty"
                                value={item?.net_issued_qty}
                                onWheel={(e) => e.target.blur()}
                                onChange={handleInputChange(originalIndex)}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                              />
                              {(item.net_issue_status === 3 || item.net_issue_status === 2) && (
                                <>
                                  <button
                                    onClick={() => handleAddButtonClick(originalIndex)}
                                    className='px-2 py-1 rounded border hover:bg-gray-300 text-sm'
                                  >
                                    +
                                  </button>
                                  {item.add_issue && (
                                    <input
                                      type="number"
                                      id="add_issued_qty"
                                      name="add_issued_qty"
                                      value={item?.add_issued_qty ?? ''}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={handleInputChange(originalIndex)}
                                      onKeyDown={(e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                          e.preventDefault();
                                        }
                                      }}
                                      className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                    />
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-2 items-center justify-end p-2 border-t border-solid border-blueGray-200 rounded-b">
                  {kit.main_store_issue_status !== 3 && (
                    <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                      {((kit.main_store_issue_status !== 3) && (kit.main_store_issue_status !== 2)) && (
                        <button
                          className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                          type="button"
                          onClick={() => handleSaveButton()}
                        >
                          Save
                        </button>
                      )}
                      <button
                        className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        disabled={kit.issue_status == 3}
                        onClick={() => handleSave()}
                      >
                        Submit for Issue
                      </button>
                      <button
                        className="bg-emerald-500 text-white active:bg-emerial-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        disabled={kit.issue_status === 3}
                        onClick={() => { handleAddNewIngredientRow() }}
                      >
                        Add Ingredient
                      </button>
                    </div>
                  )}
                  <button
                    onClick={(e) => handleExport(e, item.kit_no)}
                    className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200"
                  >
                    Export
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default IssueList;
